module.exports = __webpack_public_path__ + "img/KSC05410-2.c0e90912.jpg";